export const CACHE_KEY_CREATE_OWN_ORDER = 'create-own-order';
